export default class MarkingEvent {

    public static SLIDER_STEP_NOT_SET: string = "sliderStepNotSet";
    public static SLIDER_STEP_SET: string = "sliderStepSet";
}